import { toNowApiString } from './DateUtil'

const printPretty = (tag: string, message?: any) => {
  let logS
  if (message) {
    logS = `${tag}: ${JSON.stringify(message, null, 2)}`
  } else {
    logS = `${tag}: ${message}`
  }
  console.log(toNowApiString(), logS)
}

const ppw = (tag: string, message?: any) => {
  let logS
  if (message) {
    logS = `${tag}: ${JSON.stringify(message, null, 2)}`
  } else {
    logS = `${tag}: ${message}`
  }
  console.log(toNowApiString(), logS)
}

const pp = (tag: string) => {
  console.log(toNowApiString(), tag)
}

export { pp, ppw }

export default printPretty
